import React, { useEffect, useState, useContext } from 'react'
import { Col, Modal, Row, Button, Spinner, Alert } from 'react-bootstrap'
import { Table } from 'antd'
import { AuthContext } from '../AuthContext'
import axios from 'axios'

const DetailedInfo = ({
  detailInfoModalShow,
  setDetailInfoModalShow,
  currentPatient,
  setQrcode,
  patient_id,
  status,
}) => {
  const [isCardLoading, setIsCardLoading] = useState(false)
  const [isEmailLoading, setIsEmailLoading] = useState(false)
  const [alert, setAlert] = useState({
    show: false,
    msg: '',
    success: false,
  })
  const [currentPatientInfoDetail, setCurrentPatientInfoDetail] = useState({
    patient_id: '',
    name: '',
    family_name: '',
    gender: 0,
    birthday: '',
    email: '',
    phone: '',
    id_number: '',
    linked_ha_app: 0,
    doctor_name: '',
    live_city: '',
    live_dist: '',
    live_address: '',
    icon: '',
    data: [
      {
        record_time: '',
        doctor_name: '',
        status: 0,
        track_type: 0,
      },
    ],
  })
  const [checked, setChecked] = useState(false)
  const {
    name,
    // family_name,
    gender,
    birthday,
    // email,
    phone,
    id_number,
    linked_ha_app,
    doctor_name,
    // live_city,
    // live_dist,
    // live_address,
    // icon,
    data: [],
  } = currentPatientInfoDetail
  const { baseUrl, sendDiscordNotification, currentUser, extendCookie } =
    useContext(AuthContext)

  const statusList = ['新收案', '追蹤管理', '年度評估', '結案']
  const trackTypeList = ['初診', '電話追蹤', '訪視', '回診']

  const getPatientInfoDetail = '/api/crm/project/patient/getPatientInfoDetail'
  const [dataList, setDataList] = useState([])
  // const [isFormOpen, setisFormOpen] = useState(false)
  useEffect(() => {
    if (currentUser && currentUser.session) {
      let loadingTimer

      loadingTimer = setTimeout(() => {
        setIsCardLoading(true)
      }, 500)

      axios
        .post(
          baseUrl + getPatientInfoDetail,
          { project_id: 'P0001', patient_id: patient_id },
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Accept: '*/*',
              session: currentUser.session,
            },
          }
        )
        .then((res) => {
          if (res.data) {
            console.log('getPatientInfoDetail', res.data)
            setCurrentPatientInfoDetail(res.data)
            extendCookie()

            const newDataList = res.data.data.map((v, i) => {
              return {
                key: i + 1,
                record_time: v.record_time,
                status: statusList[v.status],
                track_type:
                  v.status === 2 || v.status === 3
                    ? ' - '
                    : trackTypeList[v.track_type],
                // viewData: '檢視資料',
                doctor_name: v.doctor_name,
              }
            })
            // console.log('newDataList', newDataList)
            setDataList(newDataList)
          }
        })
        .catch((e) => {
          console.log('getPatientInfoDetail error', e)
          sendDiscordNotification(`getPatientInfoDetail Error \n Error: ${e} `)
          alert('伺服器忙線中，請稍後再試')
        })
        .finally(() => {
          setIsCardLoading(false)
          clearTimeout(loadingTimer)
        })
    }
  }, [currentUser])

  // rowSelection object indicates the need for row selection
  const columns = [
    {
      title: '排序',
      dataIndex: 'key',
    },
    {
      title: '收案日期',
      dataIndex: 'record_time',
    },
    {
      title: '所屬醫師',
      dataIndex: 'doctor_name',
    },
    {
      title: '診療階段',
      dataIndex: 'status',
    },
    {
      title: '追蹤方式',
      dataIndex: 'track_type',
    },
    // {
    //   title: '檢視資料',
    //   dataIndex: 'viewData',
    //   render: (text) => (
    //     <div className="text-decoration-underline" style={{ color: '#67c7aa' }}>
    //       {text}
    //     </div>
    //   ),
    // },
  ]

  const rowSelection = {
    type: 'checkbox',
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        'selectedRows: ',
        selectedRows
      )
      if (selectedRows.length > 0) {
        setChecked(true)
      } else {
        setChecked(false)
      }
    },
    // getCheckboxProps: (record) => ({
    //   disabled: record.name === 'Disabled User', // Column configuration not to be checked
    //   name: record.name,
    // }),
  }

  // 匯出至信箱
  const exportEmail = '/api/crm/project/track/exportEmail'
  const handleSubmit = () => {
    if (currentUser && currentUser.session) {
      axios
        .post(
          baseUrl + exportEmail,
          { project_id: 'P0001', patient_id: patient_id },
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Accept: '*/*',
              session: currentUser.session,
            },
          }
        )
        .then((res) => {
          if (res.data) {
            console.log('exportEmail', res.data)
            if (res.data.message === '已成功寄出') {
              setAlert({
                show: true,
                msg: '已成功匯出至信箱',
                success: true,
              })
              setTimeout(() => {
                setAlert({
                  show: false,
                  msg: '',
                  success: false,
                })
              }, 3000)
              extendCookie()
            } else {
              setAlert({
                show: true,
                msg: '伺服器忙線中，請稍後再試',
                success: false,
              })
              setTimeout(() => {
                setAlert({
                  show: false,
                  msg: '',
                  success: false,
                })
              }, 3000)
            }
          }
        })
        .catch((e) => {
          console.log('exportEmail error', e)
          sendDiscordNotification(`exportEmail Error \n Error: ${e} `)
          setAlert({
            show: true,
            msg: '伺服器忙線中，請稍後再試',
            success: false,
          })
          setTimeout(() => {
            setAlert({
              show: false,
              msg: '',
              success: false,
            })
          }, 3000)
        })
        .finally(() => {})
    }
  }

  return (
    <>
      <Modal
        show={detailInfoModalShow}
        dialogClassName="formModalWidth"
        className="metabolic-syndrome-form"
        centered
      >
        <div className="m-3">
          <div
            className="align-items-center"
            onClick={() => {
              setDetailInfoModalShow(false)
            }}
            style={{ cursor: 'pointer' }}
          >
            <i className="fa-solid fa-chevron-left h3" />
            <span className="ms-3 h4">返回基本資料</span>
          </div>
        </div>
        <Modal.Body className="d-flex align-items-center flex-column m-3 h5">
          <div className="d-flex flex-column justify-content-center w-75">
            <h2 className="text-center mb-3">詳細資料</h2>
            <Row xs={2} className="mb-3">
              <Col>姓名： {name}</Col>
              <Col>性別：{gender ? '男' : '女'}</Col>
            </Row>
            <Row xs={2} className="mb-3">
              <Col>生日： {birthday}</Col>
              <Col>身分證： {id_number}</Col>
            </Row>
            <Row xs={2} className="mb-3">
              <Col>電話： {phone}</Col>
              <Col>所屬醫師： {doctor_name}</Col>
            </Row>
            <Row xs={2} className="mt-2 mb-3">
              <Col>
                結案狀態：
                {status === 3 || status === 2 ? (
                  <span className="caseClosed">已結案</span>
                ) : (
                  <span className="caseUnClosed">未結案</span>
                )}
              </Col>
              <Col>
                App 串接狀態：
                {linked_ha_app ? (
                  <span className="integrated">已串接</span>
                ) : (
                  <span className="unIntegrated">未串接</span>
                )}
              </Col>
            </Row>
            {linked_ha_app ? (
              ''
            ) : (
              <Row xs={2} className="mb-3">
                <Col></Col>
                <Col>
                  <div
                    className="text-light h5 rounded d-flex align-items-center justify-content-center py-1 px-2"
                    style={{
                      backgroundColor: '#67c7aa',
                      cursor: 'pointer',
                      width: 'fit-content',
                    }}
                    onClick={() => {
                      setQrcode({ show: true, msg: '' })
                    }}
                  >
                    <i className="fa-solid fa-qrcode text-white me-2"></i>
                    開啟 HA APP QRCode
                  </div>
                </Col>
              </Row>
            )}
          </div>
          <Table
            className="w-75"
            rowSelection={rowSelection}
            columns={columns}
            dataSource={dataList}
            pagination={false}
          />
          {alert.show && (
            <Alert
              className="mt-3"
              variant={alert.success ? 'success' : 'danger'}
              onClose={() => setAlert({ show: false, msg: '', success: false })}
              dismissible
            >
              {alert.msg}
            </Alert>
          )}
          <Button className="my-5" onClick={handleSubmit} disabled={!checked}>
            匯出資料至信箱{' '}
            <Spinner
              as="span"
              animation={isEmailLoading ? 'border' : ''}
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </Button>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default DetailedInfo
